import { splitAt } from 'ramda';

export const competenceColumns = [
    {
        columnValuePath: 'NISSAN_COMPETENCE_NAME',
        columnTranslatePath: 'xml.PplAnketa.competenceName'
    },
    {
        columnValuePath: 'NISSAN_COMPETENCE_VALUE',
        columnTranslatePath: 'xml.PplAnketa.competenceValue'
    },
];

export const educationColumns = [
    {
        columnValuePath: 'institute',
        columnTranslatePath: 'xml.PplAnketa.nissanInstitute'
    },
    {
        getValue: (row) => `${row.month_graduation || ''}${(row.month_graduation && row.year_graduation) ? '.' : ''}${row.year_graduation || ''}`,
        columnTranslatePath: 'xml.PplAnketa.nissanEducationDate'
    },
    {
        columnValuePath: 'speciality',
        columnTranslatePath: 'xml.PplAnketa.nissanSpeciality'
    },
    {
        columnValuePath: 'level',
        columnTranslatePath: 'xml.PplAnketa.nissanEdicationLevel'
    },
];

export const employmentPlacesColumns = [
    {
        columnValuePath: 'begin-date',
        columnTranslatePath: 'xml.PplAnketa.begin-date',
        formatValue: (value) => {
            const [year, month] = splitAt(4, value);

            return `${month}/${year}`
        }
    },
    {
        columnValuePath: 'end-date',
        columnTranslatePath: 'xml.PplAnketa.end-date',
        formatValue: (value) => {
            const [year, month] = splitAt(4, value);

            return `${month}/${year}`
        }
    },
    {
        columnValuePath: 'organization',
        columnTranslatePath: 'xml.PplAnketa.organization'
    },
    {
        columnValuePath: 'position',
        columnTranslatePath: 'xml.PplAnketa.position'
    },
    {
        columnValuePath: 'function',
        columnTranslatePath: 'xml.PplAnketa.workFunction'
    },
];
